import { Injectable } from '@angular/core';
import { without } from '@sama/micro-dash';
import { InjectableSuperclass } from '@sama/ng-core';

@Injectable({ providedIn: 'root' })
export class NavigationWarningService extends InjectableSuperclass {
  private warnFns: Array<() => boolean> = [];

  constructor() {
    super();
    window.onbeforeunload = (event: BeforeUnloadEvent) => {
      if (this.hasChanges()) {
        // `preventDefault` is the spec-compliant way to do this, setting
        // `returnValue` is what Chrome uses. We do both in case Chrome decides
        // to start following the spec. (They already broke this once by
        // changing from an even older behavior.)
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
        event.preventDefault();
        event.returnValue = '';
      }
    };
  }

  register(hasChangesFn: () => boolean, injectable: InjectableSuperclass) {
    this.warnFns.push(hasChangesFn);
    this.unregisterOnDestroy(hasChangesFn, injectable);
  }

  hasChanges() {
    return this.warnFns.some((fn) => fn());
  }

  private unregisterOnDestroy(
    hasChangesFn: () => boolean,
    injectable: InjectableSuperclass,
  ) {
    const unregisterFn = this.unregister.bind(this, hasChangesFn);
    this.subscribeTo(injectable.destruction$, unregisterFn);
  }

  private unregister(hasChangesFn: () => boolean) {
    this.warnFns = without(this.warnFns, hasChangesFn);
  }
}
